import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { motion } from 'motion/react'
import teamChristina from '../assets/team-christina.webp'
import teamEva from '../assets/team-eva.webp'
import teamAgustin from '../assets/team-agustin.webp'

const teamImages = [teamChristina, teamEva, teamAgustin]

export default function WhyBuenas() {
  const { t } = useTranslation()
  const [current, setCurrent] = useState(0)

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % teamImages.length)
    }, 4000)
    return () => clearInterval(timer)
  }, [])

  return (
    <section className="bg-white">
      <div className="grid grid-cols-1 md:grid-cols-2">
        {/* Left – Cycling team images */}
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.7, ease: 'easeOut' }}
          className="flex items-center justify-center p-8 md:p-16"
        >
          <div className="relative w-full max-w-sm overflow-hidden">
            {teamImages.map((src, i) => (
              <img
                key={src}
                src={src}
                alt={`buenas team ${i + 1}`}
                className={`w-full object-cover absolute inset-0 transition-opacity duration-1000 ${
                  i === current ? 'opacity-100' : 'opacity-0'
                }`}
              />
            ))}
            <img
              src={teamImages[0]}
              alt="buenas studio team"
              className="w-full object-cover invisible"
            />
          </div>
        </motion.div>

        {/* Right – Text */}
        <motion.div
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.7, delay: 0.15, ease: 'easeOut' }}
          className="flex flex-col justify-center p-10 md:p-16"
        >
          <p className="font-body text-rot text-xs tracking-widest uppercase mb-3">
            {t('twinPower.kicker')}
          </p>
          <h2 className="font-headline text-espresso text-4xl md:text-5xl mb-6">
            {t('twinPower.h2')}
          </h2>
          <p className="font-body text-espresso/70 text-base leading-relaxed mb-10 max-w-lg">
            {t('twinPower.text')}
          </p>
          <div>
            <a
              href="#contact"
              className="bg-espresso text-sand rounded-full px-8 py-3 font-body hover:bg-rot transition-colors inline-block"
            >
              {t('twinPower.button')}
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  )
}
